import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Player from '@vimeo/player';

import ImageVideoCover from 'components/atoms/imageVideoCover';
import { imageCoverOut } from 'components/utils/animation';
import './style.css';

class ProjectVideo extends Component {
    state = {
        vimeoPlayer: null
    };

    componentWillReceiveProps(newProps) {
        const hasURL = newProps.url !== '' ? true : false;

        if (hasURL && this.vimeoIframe) {
            this.setState({
                vimeoPlayer: new Player(this.vimeoIframe)
            });
        }
    }

    playVideo = () => {
        this.state.vimeoPlayer
            .play()
            .then(item => {
                imageCoverOut(this.videoCover);
            })
            .catch(error => {
                imageCoverOut(this.videoCover);
                console.warn('vimeo could not autoplay', error);
            });
    };

    render() {
        const { title, url, cover, coverTitle } = this.props;
        const hasURL = url !== '' ? true : false;
        return (
            <div className="ProjectVideo">
                <div className="ProjectVideo__video">
                    {hasURL ? (
                        <iframe
                            title={title}
                            src={url}
                            width="640"
                            height="360"
                            frameBorder="0"
                            mozallowfullscreen="true"
                            allowFullScreen="true"
                            webkitallowfullscreen="true"
                            allow="autoplay"
                            ref={iframe => {
                                this.vimeoIframe = iframe;
                            }}
                        />
                    ) : null}
                </div>

                <div
                    className="ProjectVideo__cover"
                    onClick={this.playVideo}
                    ref={cover => {
                        this.videoCover = cover;
                    }}
                >
                    <div className="ProjectVideo__cover__image">
                        <ImageVideoCover url={cover} title={coverTitle} />
                    </div>
                    <div className="ProjectVideo__cover__text">Play</div>
                </div>
            </div>
        );
    }
}

ProjectVideo.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    cover: PropTypes.string,
    coverTitle: PropTypes.string
};

ProjectVideo.defaultProps = {
    title: 'Video title',
    url: 'https://player.vimeo.com/video/251344009',
    cover: 'https://picsum.photos',
    coverTitle: 'Image title'
};

export default ProjectVideo;



// WEBPACK FOOTER //
// ./src/components/molecules/projectVideo/index.js